
import { Vue, Component, Watch } from 'vue-property-decorator'
import NavItems from '../components/NavItems.vue'
import { PackageItemGroup, PackageItem, routerDir } from '../constant'
import { use } from '@@/utils'

const [ bem ] = use('layout')

@Component({
  components: {
    // pit 如果使用 tsx，必须使用小写
    // 反之使用 template 必须使用 大写
    // https://github.com/vuejs/vue-cli/issues/2417#issuecomment-419667646
    'nav-items': NavItems
  }
})
export default class Layout extends Vue {
  navItems: PackageItemGroup[] = routerDir
  demoSrc: string = ''
  docScrollTop: number = 0

  get isScrollOut (): boolean {
    return this.docScrollTop > 40
  }

  @Watch('$route.path')
  onRouteChange (val: string) {
    this.changeIframe(val.substr(1))
  }

  created () {
    this.changeIframe(this.$route.path.substr(1))
  }

  mounted () {
    window.onscroll = () => {
      this.docScrollTop = document.documentElement.scrollTop
    }
  }

  navChange (nav: PackageItem) {
    this.changeIframe(nav.name)
  }

  changeIframe (pathName: string) {
    this.demoSrc = routerDir.some(obj => obj.items.some(x => pathName === x.name && x.noDemo === true))
      ? ''
      : `./demo.html#/${pathName}`
  }

  render () {
    return (
      <div class={bem()}>
        <div class={bem('top', false)}>
          <div class={bem('top', 'content', false)}>
            <a class={bem('top', 'title', false)} href="">
              <img src={require('../assets/logo.png')} width="40px" alt="" />
              <div>
                <span>{'Esc-ui'}</span>
                <span class={bem('top', 'content-small', false)}> 业务组件库</span>
              </div>
            </a>
            <ul>
              <li><a target="_blank" href="https://github.com/Jmingzi/esc-ui">Github</a></li>
            </ul>
          </div>
        </div>
        <div class={(this.isScrollOut ? bem('left', 'sticky') : bem('left', false))}>
          <nav-items list={this.navItems} onChange={this.navChange} />
        </div>
        <div class={bem('center', false)}>
          <div class="van-doc-content">{this.$slots.center}</div>
        </div>
        {
          this.demoSrc ? (
            <div class={(this.isScrollOut ? bem('right', 'sticky') : bem('right', false))}>
              <iframe slot="right" src={this.demoSrc} frameBorder="0"/>
            </div>
          ) : null
        }
      </div>
    )
  }
}
